export class SnGoogleGeocoderAddressComponents {
  public city: string;
  public state: string;
  public country: string;
  public county: string;
  public zip: string;
  public route: string;
  public streetNumber: string;
  public address: string;
  public postalTown: string;

  constructor(data: google.maps.GeocoderAddressComponent[]) {
    this._decodeAddressComponents(data);
  }

  private _decodeAddressComponents(components: google.maps.GeocoderAddressComponent[]): void {
    components.forEach((value) => {
      // Type[0] contains type of address component
      switch (value.types[0]) {
        case 'administrative_area_level_1':
          this.state = value.short_name;
          break;
        case 'administrative_area_level_2':
          this.county = value.short_name;
          break;
        case 'locality':
          this.city = value.long_name;
          break;
        case 'country':
          this.country = value.long_name;
          break;
        case 'postal_code':
          this.zip = value.long_name;
          break;
        case 'postal_code_prefix':
          this.zip = value.long_name;
          break;
        case 'postal_town':
          this.postalTown = value.long_name;
          break;
        case 'route':
          this.route = value.long_name;
          break;
        case 'street_number':
          this.streetNumber = value.long_name;
          break;
        case 'plus_code':
          this.streetNumber = value.long_name;
          break;
      }
    });

    const address: string[] = [];

    if (this.streetNumber) {
      address.push(this.streetNumber);
    }

    if (this.route) {
      address.push(this.route);
    }

    this.address = address.join(' ');

    if (!this.state) {
      this.state = this.country;
    }
  }
}
